import { render, staticRenderFns } from "./GiftNew.vue?vue&type=template&id=55d586b4"
import script from "./GiftNew.vue?vue&type=script&lang=js"
export * from "./GiftNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports